import { CondicionIvaModel } from './condicionIva.model';
import { AfipModel } from './afip.model';
import { GenericPlace } from './generic-place.model';
import { ActivityModel } from './activity.model';

export class OrganismModel {
  public id: number;
  public nombre: string;
  public descripcion: string;
  public servicioList: Array<any>;
  public codigoEntidad: number;
  public generarInforme: boolean;
  public nombreEntidad: string;
  public calle: string;
  public calleNumero: string;
  public ciudad: string;
  public codigoPostal: string;
  public razonSocial: string;
  public condicionIVA: string;
  public tipoDocumento: string;
  public numeroDocumento: string;
  public actividadAfip: string;
  public domicilioFiscal: string;
  public cbuAlias: string;
  public campoServicioEMVco: string;
  public rubroServicio: string;
  public afipData: AfipModel;
  public ubicacion: GenericPlace;
  public rubro: ActivityModel;

  constructor() {
    this.servicioList = Array<any>();
    this.afipData = new AfipModel();
    this.ubicacion = new GenericPlace();
    this.rubro = new ActivityModel();
  }
}
